import { render, staticRenderFns } from "./modelList.vue?vue&type=template&id=4ca16a14&scoped=true"
import script from "./modelList.vue?vue&type=script&lang=js"
export * from "./modelList.vue?vue&type=script&lang=js"
import style0 from "./modelList.vue?vue&type=style&index=0&id=4ca16a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca16a14",
  null
  
)

export default component.exports